import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderPickupSchema = {
    name: Schema.String,
    phone_number: Schema.String,
    address: Schema.String,
    notes: Schema.String,
    location: Schema.Auto,
    detailed_address: Schema.Auto,
};
